import { TractorListToolPanel } from "../TractorListToolPanel";
import { DataSource, Layout, LayoutHeader, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutTractorList extends Layout {
    layoutTractorListTools: TractorListToolPanel;
    layoutheaderTractorList: LayoutHeader;
    panelTractorList: Panel;
    sourceTractor: DataSource;
    tableTractors: Table;
}
